import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'

export const scheduledUpcomingRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.upcoming,
  path: 'upcoming',
  redirect: { name: ScheduledRoutes.upcomingOverview },
  component: () => import('@/components/views/scheduled/ScheduledUpcoming.vue'),
  meta: {},
  children: [
    {
      name: ScheduledRoutes.upcomingOverview,
      path: '',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.upcoming',
        tags: ['SCHEDULED_BAR_LIST'],
        modules: [AppModule.ScheduledUpcoming, AppModule.ScheduledNotSent],
      },
      component: () => import('@/components/views/scheduled/ScheduledUpcomingSms.vue'),
    },
    {
      name: ScheduledRoutes.upcomingOverviewEmail,
      path: 'email',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.upcomingEmail',
        modules: [AppModule.ScheduledEmail, AppModule.Recipient, AppModule.CampaignsSenders],
      },
      component: () => import('@/components/views/scheduled/ScheduledUpcomingEmail.vue'),
    },
  ],
}
